import React, {useState} from 'react';

import Button from './ButtonNew';
import {ConnectedButton, ConnectedButtonGroup} from './ConnectedButton';
import {StyledTextArea as TextArea} from './Forms';

const RatingType = {
  UP: 'up',
  DOWN: 'down',
  FEEDBACK: 'feedback',
};

const RatingWidget = ({
  initialRating,
  onRate,
  onSubmitFeedback,
  className,
}) => {
  const [rating, setRating] = useState(initialRating);
  const [showTextArea, setShowTextArea] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const onClickRate = (e) => {
    const newRating = e.currentTarget.value;
    if (newRating !== rating) {
      if (newRating !== RatingType.FEEDBACK) onRate(newRating);
      setRating(newRating);
      setShowTextArea(true);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    onSubmitFeedback(formData.get('feedback'));
    setShowTextArea(false);
    setShowThankYou(true);
  };

  const getPlaceholderText = () => {
    switch (rating) {
      case RatingType.UP: return 'What did you like?';
      case RatingType.DOWN: return 'What can be improved? We love actionable feedback!';
      case RatingType.FEEDBACK: return 'We love actionable feedback!';
      default: return '';
    }
  };

  return (
    <div className={className}>
      <div className="flex items-center">
        <span className="mr-5">Was this helpful?</span>
        <ConnectedButtonGroup>
          <ConnectedButton
            onClick={onClickRate}
            selected={rating === RatingType.UP}
            value={RatingType.UP}
          >
            <span role="img" aria-label="thumbs up">👍</span>
          </ConnectedButton>
          <ConnectedButton
            onClick={onClickRate}
            selected={rating === RatingType.DOWN}
            value={RatingType.DOWN}
          >
            <span role="img" aria-label="thumbs down">👎</span>
          </ConnectedButton>
          <ConnectedButton
            onClick={onClickRate}
            selected={rating === RatingType.FEEDBACK}
            value={RatingType.FEEDBACK}
          >
            Send feedback
          </ConnectedButton>
        </ConnectedButtonGroup>
      </div>
      {showTextArea && (
        <form onSubmit={onSubmit} className="flex flex-col items-end mt-3">
          <TextArea
            name="feedback"
            placeholder={getPlaceholderText()}
            className="text-base font-normal text-gray-600"
          />
          <Button type="submit" className="block mt-2">Submit</Button>
        </form>
      )}
      {showThankYou && <div className="text-center mt-5">Thank you!</div>}
    </div>
  );
};

export default RatingWidget;
